import jobTitlesApi from './axios/job-titles-api';

const fetchCoursesForAssignment = async (params = {}) => {
  const response = await jobTitlesApi.getAvailableCourses(params);
  if (response.error) {
    console.error('[coursesForAssignment]', response.error);
    return { data: [], pagination: null };
  }
  return {
    data: response.data || [],
    pagination: response.pagination || null,
  };
};

export default fetchCoursesForAssignment;
